import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import usePiwik from 'src/hooks/usePiwik'

import { postCampaignsBulkSubscriptionRequest } from '../../OngageUnsubscribeSlice'
import {
  selectCampaigns,
  selectLoadingUnsubscribe,
  selectObfuscatedEmail,
  selectUnsubscribeSuccess
} from '../../OngageUnsubscribeSelector'

import { piwikFirstWordGroupSiteId } from 'src/constants'

import Spinner from 'src/lib/ui/Spinner'
import {
  OngageCampaignsForm,
  OngageCampaignsConfirmation,
  OngageSuccess
} from 'appdev-ui-library'

const Step = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { handleOngageActionTracking } = usePiwik()
  const campaigns = useSelector(selectCampaigns)
  const obfuscatedEmail = useSelector(selectObfuscatedEmail)
  const bulkUnsubscribeSucced = useSelector(selectUnsubscribeSuccess)
  const loading = useSelector(selectLoadingUnsubscribe)

  const [step, setStep] = useState(1)
  const [memberId, setMemberId] = useState()
  const [emailId, setEmailId] = useState()
  const [profileCampaigns, setProfileCampaigns] = useState(campaigns)

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search)
    setMemberId(queryParams.get('MemberID'))
    setEmailId(queryParams.get('EmailID'))

    history.replace(window.location.pathname)
  }, [history])

  useEffect(() => {
    if (memberId && emailId) {
      switch (step) {
        case 1:
          handleOngageActionTracking(
            piwikFirstWordGroupSiteId,
            'Site/View/Unsubscribe',
            memberId,
            emailId
          )
          break
        case 2:
          handleOngageActionTracking(
            piwikFirstWordGroupSiteId,
            'Site/View/Unsubscribe/ConfirmationPage',
            memberId,
            emailId
          )
          break
        case 3:
          handleOngageActionTracking(
            piwikFirstWordGroupSiteId,
            'Site/View/Unsubscribe/Success',
            memberId,
            emailId
          )
          break
      }
    }
  }, [step, memberId, emailId])

  useEffect(() => {
    if (campaigns) setProfileCampaigns(campaigns)
  }, [campaigns])

  useEffect(() => {
    if (bulkUnsubscribeSucced) {
      setStep(3)
    }
  }, [bulkUnsubscribeSucced])

  const handleFormSubmit = updatedCampaigns => {
    setProfileCampaigns(updatedCampaigns)
    handleOngageActionTracking(
      piwikFirstWordGroupSiteId,
      'Site/Click/Unsubscribe/UpdatePreferences',
      memberId,
      emailId
    )
    setStep(2)
  }

  const handleConfirmation = () => {
    handleOngageActionTracking(
      piwikFirstWordGroupSiteId,
      'Site/Click/Unsubscribe/form/submit',
      memberId,
      emailId
    )
    const payload = profileCampaigns.map(({ label, ...rest }) => rest)
    dispatch(postCampaignsBulkSubscriptionRequest(payload))
  }

  const handleGoBack = () => {
    handleOngageActionTracking(
      piwikFirstWordGroupSiteId,
      'Site/Click/Unsubscribe/clickhere',
      memberId,
      emailId
    )
    setStep(1)
  }

  if (loading) {
    return <Spinner fillColor="transparent" strokeColor="rgba(213,213,213,1)" />
  }

  switch (step) {
    case 1:
      return (
        <OngageCampaignsForm
          title={`Manage communication preferences for ${obfuscatedEmail}`}
          subtitle="If this is not your email address, please ignore this page. If you have any questions, contact us."
          infoText="Uncheck the types of marketing emails you do not want to receive:"
          textFont="Helvetica"
          linkColor="#e27746"
          linkText="contact us"
          linkHref="/contact-us"
          options={profileCampaigns}
          checkboxCheckedColor="#000000"
          buttonLabel="UPDATE EMAIL PREFERENCES"
          buttonColor="warning"
          onContinue={handleFormSubmit}
        />
      )
    case 2:
      return (
        <OngageCampaignsConfirmation
          title="Please review your changes below and click the confirm button."
          subtitle="If you would like to modify these changes, please"
          options={profileCampaigns}
          textFont="Helvetica"
          goBackText="click here"
          goBackTextColor="#e27746"
          buttonColor="warning"
          buttonLabel="CONFIRM"
          onGoBack={handleGoBack}
          onConfirm={handleConfirmation}
        />
      )
    case 3:
      return (
        <OngageSuccess
          title="Success! Your email preferences have been updated."
          subtitle="Please allow 24-48 hours for your changes to take effect"
          textFont="Helvetica"
        />
      )
    default:
      return null
  }
}

export default Step
